'use client'

import RegisterSection from '@/components/home/RegisterSection';


const CampSchedules = () => {
	return (
		<div className='max-w-[1920px] mx-auto bg-white min-h-[calc(100vh-350px)]'>
            <div className='py-10 mx-10'>
			    <RegisterSection/>	
            </div>
        </div>
        );
};

export default CampSchedules;
